import { render, staticRenderFns } from "./SearchResultStudent.vue?vue&type=template&id=55423364&scoped=true&lang=pug"
import script from "./SearchResultStudent.vue?vue&type=script&lang=ts"
export * from "./SearchResultStudent.vue?vue&type=script&lang=ts"
import style0 from "./SearchResultStudent.vue?vue&type=style&index=0&id=55423364&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55423364",
  null
  
)

export default component.exports